import React, { FC }      from 'react';
import { makeStyles }     from "@material-ui/core/styles";
import Grid, { GridSize } from '@material-ui/core/Grid';
import Paper              from "@material-ui/core/Paper";
import Typography         from "@material-ui/core/Typography";

export interface GridContainerProps {
    size: GridSize;
    title: string;
}

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column'
    },
}));

export const GridContainer: FC<GridContainerProps> = ({ size, children, title }) => {
    const classes = useStyles();

    return <Grid item sm={ size } xs={12}>
        <Paper className={ classes.paper }>
            <Typography variant={ 'h6' }>{ title }</Typography>
            { children }
        </Paper>
    </Grid>
}